import { ToastProvider, ToastViewport } from '@/components/ui/toast';
import { ToastDeck } from '@/components/ui/toast-deck';
import { useToast } from '@/hooks/use-toast';

export function Toaster() {
  const { toasts } = useToast();

  return (
    <ToastProvider swipeDirection="down">
      <ToastViewport>
        <ToastDeck toasts={toasts} />
      </ToastViewport>
    </ToastProvider>
  );
}
